import React from 'react';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaArrowRight, FaStar } from 'react-icons/fa';
import './Sponsorship.css';

const Sponsorship = () => {
  const sponsorshipPackages = [
    { category: 'Platinum', range: '>75k', exhibitionStall: 'Yes', freeDelegates: '2', advertisement: 'Full Page' },
    { category: 'Gold', range: '50-75k', exhibitionStall: 'Yes', freeDelegates: '2', advertisement: 'Half Page' },
    { category: 'Silver', range: '25-50k', exhibitionStall: 'N/A', freeDelegates: '1', advertisement: '1/4 Page' },
    { category: 'Bronze', range: '0-25k', exhibitionStall: 'N/A', freeDelegates: 'N/A', advertisement: '1/4 Page' }
  ];

  // Add tier: 'platinum' | 'gold' | 'silver' | 'bronze' to each sponsor
  const sponsors = [
    {
      id: 'nucleotech',
      tier: 'silver',
      name: 'M/s. Nuclotech Solutions',
      logo: '/nucleotech.png'
    },
    {
      id: 'holmarc',
      tier: 'silver',
      name: 'Holmarc Opto-Mechatronics',
      logo: '/holmarc.png'
    },
    {
      id: 'pfieffer',
      tier: 'silver',
      name: 'Pfeiffer Vacuum',
      logo: '/pfieffer.png'
    },
    {
      id: 'ants',
      tier: 'silver',
      name: 'M/s. Ants Innovations',
      logo: '/ants.png'
    },
    {
      id: 'infinity',
      tier: 'bronze',
      name: 'M/s. Infinity Systems',
      logo: '/Infinity_Logo.png'
    },
    {
      id: 'labquip',
      tier: 'bronze',
      name: 'Labquip',
      logo: '/labquip.png'
    },
    {
      id: 'vbceramics',
      tier: 'bronze',
      name: 'VB Ceramics',
      logo: '/vbceramics.png'
      },
    {
      id: 'canarabank',
      tier: 'gold',
      name: 'Canara Bank',
      logo: '/canara.jpg'
    },
    {
      id: 'irtech',
      tier: 'platinum',
      name: 'IR Tech',
      logo: '/irtech.jpg'
      }
  ];

  const tierConfig = {
    platinum: { label: 'Platinum Sponsors', color: '#C9A227' },
    gold:     { label: 'Gold Sponsors',     color: '#D4A017' },
    silver:   { label: 'Silver Sponsors',   color: '#7a7a7a' },
    bronze:   { label: 'Bronze Sponsors',   color: '#8B4513' },
  };

  // Group sponsors by tier in display order
  const tierOrder = ['platinum', 'gold', 'silver', 'bronze'];
  const grouped = tierOrder
    .map(tier => ({ tier, items: sponsors.filter(s => s.tier === tier) }))
    .filter(g => g.items.length > 0);

  const benefits = [
    'Brand visibility and recognition at a prestigious academic conference',
    'Networking opportunities with industry leaders and academic professionals',
    'Access to a diverse audience of researchers, students, and industry experts',
    'Exhibition stall opportunities (for selected packages)',
    'Free delegate passes for company representatives',
    'Recognition in conference proceedings and promotional materials',
    'Enhanced corporate image and social responsibility',
    'Opportunity to showcase products, services, and innovations'
  ];

  const contactDetails = {
    email: 'ncamst2026@iiitk.ac.in',
    phone1: 'Dr. P V Prakash Madduri: 08518-289122',
    phone2: 'Dr. P. Kishore: kishore@iiitk.ac.in / 08518-289240',
    address: 'Department of Sciences, IIITDM Kurnool, Jagannathagattu Hill, Kurnool, Andhra Pradesh-518008, India'
  };

  return (
    <div className="sponsorship-page">

      {/* ════════════════════════════════════════
          HERO BANNER — matching home page style
          ════════════════════════════════════════ */}
      <div className="sp-hero">
        <div className="sp-hero-top-section">
          <img src="/iiitlogo.png" alt="IIITDM Kurnool" className="sp-hero-side-logo sp-hero-logo-left" />

          <div className="sp-hero-title-block">
            <p className="sp-hero-sponsored">DST/ANRF and CSIR Sponsored</p>
            <h4 className="sp-hero-subtitle">National Conference on</h4>
            <h1 className="sp-hero-title">Advanced Materials for Sustainable Technologies</h1>
            <h2 className="sp-hero-shortform">(NCAMST-2026)</h2>
          </div>

          <img src="/decennial.png" alt="Decennial Celebration" className="sp-hero-side-logo sp-hero-logo-right" />
        </div>

        <div className="sp-hr" />

        {/* Supported By */}
        <p className="sp-supported-label">NCAMST-2026 is Supported By</p>

        <div className="sp-funders-row">
          <img src="/ANRF.jpg" alt="Anusandhan National Research Foundation" className="sp-funder-img sp-funder-large" />
          <div className="sp-vr" />
          <img src="/csir.png" alt="CSIR" className="sp-funder-img sp-funder-large" />
        </div>

        <div className="sp-hr" />

        {/* Sponsors grouped by tier */}
        {grouped.map(({ tier, items }) => (
          <div key={tier} className="sp-tier-group">
            <p
              className="sp-tier-label"
              style={{ color: tierConfig[tier].color }}
            >
              {tierConfig[tier].label}
            </p>
            <div className="sp-other-row">
              {items.map(s => (
                s.logo
                  ? <img key={s.id} src={s.logo} alt={s.name} className="sp-other-logo sp-sponsor-logo-large" />
                  : <div key={s.id} className="sp-sponsor-placeholder">{s.name}</div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* ════════════════════════════════════════
          SPONSORSHIP DETAILS
          ════════════════════════════════════════ */}
      <div className="sponsorship-container">

        {/* Benefits */}
        <section className="benefits-section">
          <h2 className="section-title">Why Sponsor NCAMST-2026?</h2>
          <ul className="benefits-list">
            {benefits.map((b, i) => (
              <li key={i} className="benefit-item">
                <span className="benefit-icon">✓</span>
                <span className="benefit-text">{b}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Packages */}
        <section className="packages-section">
          <h2 className="section-title">Sponsorship Packages</h2>
          <div className="table-wrapper">
            <table className="sponsorship-table">
              <thead>
                <tr>
                  <th>Category</th><th>Amount Range</th><th>Exhibition Stall</th>
                  <th>Free Delegates</th><th>Advertisement</th>
                </tr>
              </thead>
              <tbody>
                {sponsorshipPackages.map((pkg, i) => (
                  <tr key={i}>
                    <td className={`category-cell ${pkg.category.toLowerCase()}`}>{pkg.category}</td>
                    <td>₹{pkg.range}</td>
                    <td>{pkg.exhibitionStall}</td>
                    <td>{pkg.freeDelegates}</td>
                    <td>{pkg.advertisement}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Payment Terms */}
        <section className="payment-terms-section">
          <h2 className="section-title">Payment Terms</h2>
          <div className="payment-terms-card">
            <ul className="payment-terms-list">
              <li>The Tax Invoice will be issued after receipt of the full payment.</li>
              <li>All payments must be completed 30 days prior to the commencement of NCAMST-2026.</li>
              <li>GST will be applicable as per prevailing rules.</li>
            </ul>
          </div>
        </section>

        {/* Account Details */}
        <section className="account-details-section">
          <h2 className="section-title">Account Details</h2>
          <div className="account-details-grid">
            <div className="account-details-card">
              <h3 className="account-card-title">Bank Information</h3>
              <div className="account-detail-item"><span className="detail-label">Bank Name:</span><span className="detail-value">ICICI BANK</span></div>
              <div className="account-detail-item"><span className="detail-label">Account Name:</span><span className="detail-value">IIITDM KURNOOL</span></div>
              <div className="account-detail-item"><span className="detail-label">Account Number:</span><span className="detail-value">756701001024</span></div>
              <div className="account-detail-item"><span className="detail-label">IFSC CODE:</span><span className="detail-value">ICIC0007567</span></div>
              <div className="account-detail-item"><span className="detail-label">MICR CODE:</span><span className="detail-value">518229009</span></div>
              <div className="account-detail-item"><span className="detail-label">Branch Name:</span><span className="detail-value">C-Camp Kurnool</span></div>
            </div>
            <div className="qr-code-card">
              <h3 className="account-card-title">Payment QR Code</h3>
              <div className="qr-code-container">
                <img src="/qr.png" alt="Payment QR Code" className="qr-code-image" />
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="sponsorship-contact-section">
          <h2 className="section-title">Contact Information</h2>
          <div className="contact-cards-grid">
            <div className="contact-info-card">
              <div className="contact-card-icon"><FaEnvelope /></div>
              <h3 className="contact-card-title">Email</h3>
              <p className="contact-card-text">{contactDetails.email}</p>
            </div>
            <div className="contact-info-card">
              <div className="contact-card-icon"><FaPhoneAlt /></div>
              <h3 className="contact-card-title">Phone</h3>
              <p className="contact-card-text">{contactDetails.phone1}</p>
              <p className="contact-card-text">{contactDetails.phone2}</p>
            </div>
            <div className="contact-info-card">
              <div className="contact-card-icon"><FaMapMarkerAlt /></div>
              <h3 className="contact-card-title">Address</h3>
              <p className="contact-card-text">{contactDetails.address}</p>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="cta-section">
          <div className="cta-card">
            <h2 className="cta-title">Ready to Become a Sponsor?</h2>
            <p className="cta-description">Join us in making NCAMST-2026 a memorable event.</p>
            <a href="https://forms.gle/c7pcLcyXUfqHKL2GA" target="_blank" rel="noopener noreferrer" className="cta-button">
              <span>Become a Sponsor</span>
              <FaArrowRight className="button-icon" />
            </a>
          </div>
        </section>

      </div>
    </div>
  );
};

export default Sponsorship;
